export default "/age/@years";
